import { render, staticRenderFns } from "./ListOffer.vue?vue&type=template&id=180b3b6c&scoped=true"
import script from "./ListOffer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListOffer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListOffer.vue?vue&type=style&index=0&id=180b3b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b3b6c",
  null
  
)

export default component.exports